import { render } from "./ResumeSectionStandard.vue?vue&type=template&id=404481a4"
import script from "./ResumeSectionStandard.vue?vue&type=script&lang=js"
export * from "./ResumeSectionStandard.vue?vue&type=script&lang=js"

import "./ResumeSectionStandard.vue?vue&type=style&index=0&id=404481a4&lang=css"
script.render = render

export default script